import React from "react";
import {Button, ModalFooterButtons} from "@reside/ui";
import {ResidentsListTable} from "../ListOfResidents";
import {Form, Formik} from "formik";
import {useLinkResidentToAdmission} from "../../hooks/useLinkResidentToAdmission";

export const LinkAnotherResidentRadioForm = ({
  closeModal,
  onLinked,
  workflowType,
}: {
  workflowType: string;
  closeModal: () => void;
  onLinked: () => void;
}): JSX.Element => {
  const {mutate} = useLinkResidentToAdmission(workflowType, () => {
    closeModal();
    onLinked();
  });

  return (
    <Formik
      initialValues={{resident: ""}}
      onSubmit={values => mutate(JSON.parse(values.resident))}
    >
      <Form>
        <ResidentsListTable openDetailsOnClick={false} />
        <ModalFooterButtons>
          <Button onClick={() => closeModal()}>Cancel</Button>
          <Button type="submit" color="primary">
            Link
          </Button>
        </ModalFooterButtons>
      </Form>
    </Formik>
  );
};
